import { SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';
import './Label.scss';

interface AppLabelProps {
  label: string;
  className?: string;
  sx?: SxProps<Theme>;
}

const AppLabel: FC<AppLabelProps> = ({ label, className, ...props }) => {
  return (
    <Typography fontSize={16} fontWeight={400} className={className} {...props}>
      {label}
    </Typography>
  );
};

export default AppLabel;
